import { render, staticRenderFns } from "./HelpItem.vue?vue&type=template&id=abc42c3c&scoped=true&"
import script from "./HelpItem.vue?vue&type=script&lang=js&"
export * from "./HelpItem.vue?vue&type=script&lang=js&"
import style0 from "./HelpItem.vue?vue&type=style&index=0&id=abc42c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc42c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
